import { UTM_COOKIE_MAP } from '../../constants';
import { useSelector } from 'react-redux';
import { createReducer, createAction } from 'redux-act';
import { IGlobalState } from '../index';
import { IYMetrics, ITrafficSource } from '../../services/settings';
import { ISiteSettings } from '@sravni/types/lib/sitesettings';

export interface IState extends ISiteSettings {
    yandexMetrics?: IYMetrics;
    trafficSource?: ITrafficSource;
}

const initialState = {
    header: {
        menu: undefined,
        mobileMenu: undefined,
    },
    footer: {
        menu: undefined,
        socialLinks: undefined,
        support: undefined,
    },
} as unknown as IState;

export const setSettings = createAction<Partial<IState>>('set sitesettings');

export const setTrafficSource = createAction<ITrafficSource>('set trafficSource');

export const useTrafficSource = () => useSelector((state: IGlobalState) => state.siteSettings.trafficSource);

export const useTrafficSourceAsUtmURIString = (makeEncodeString?: boolean) =>
    useSelector((state: IGlobalState) => {
        const utmTags = state.siteSettings.trafficSource;
        if (!utmTags) {
            return '';
        }

        const utmTagsKeys = Object.keys(utmTags) as Array<keyof typeof utmTags>;

        const allUtmTagsString = utmTagsKeys.reduce((previous, key) => {
            const utmTagString = `${UTM_COOKIE_MAP[key]}=${utmTags[key]}`;
            return previous === '' ? utmTagString : `${previous}|${utmTagString}`;
        }, '');

        return makeEncodeString ? encodeURIComponent(allUtmTagsString) : allUtmTagsString;
    });

export const siteSettingsReducer = createReducer({}, initialState)
    .on(setSettings, (state, data) => ({ ...state, ...data }))
    .on(setTrafficSource, (state, trafficSource) => ({ ...state, trafficSource }));
